import config from './config';

const defaultFlags = {
  'check-if-human': false,
  'rebooking-reminder-sms': false,
};

let ldClient = null;

if (window.LDClient) {
  ldClient = window.LDClient.initialize(
    config.launchDarkly.clientSideId,
    {
      kind: 'user',
      key: 'anonymous',
      anonymous: true,
    }
  );
}

export const getFlag = async (flagName, context) => {
  if (ldClient) {
    if (context) {
      // Change context and evaluate flag with new context
      await ldClient.waitUntilReady();
      await ldClient.identify(context);
      const evaluation = ldClient.variation(flagName, defaultFlags[flagName]);
      // Revert back to original context
      await ldClient.identify({
        kind: 'user',
        key: 'anonymous',
        anonymous: true,
      });
      return evaluation;
    }
    return ldClient.variation(flagName, defaultFlags[flagName]);
  }

  return defaultFlags[flagName];
};

export default getFlag;



// WEBPACK FOOTER //
// ./src/flags.js